import { render, staticRenderFns } from "./FluxoCarneDevolvidos.vue?vue&type=template&id=05d1b202&scoped=true"
import script from "./FluxoCarneDevolvidos.vue?vue&type=script&lang=js"
export * from "./FluxoCarneDevolvidos.vue?vue&type=script&lang=js"
import style0 from "./FluxoCarneDevolvidos.vue?vue&type=style&index=0&id=05d1b202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d1b202",
  null
  
)

export default component.exports